module.exports = __webpack_public_path__ + "img/yuyuko saigyouji tiny ghost mistress_sc2.f76ff082.png";